<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.FanCalculation.ReportBtn }}

            <p class="control" slot="right">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>
            <div class="wizard-body">
                <pdf-frame :src="pdfsrc" :loading="isLoading" :failed="pdfFailed" />
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import PdfFrame from '@/components/PdfFrame.vue';

    export default {
        name: 'FanPdfPage',
        components: {
            VerticalStepBar,
            PdfFrame
        },
        data() {
            return {
                isLoading: false,
                pdfFailed: false,
                pdfsrc: ''
            }
        },
        mounted() {
            this.getFanPdf(this.$store.state.projectId);
            this.$store.state.activeStep = 5;
        },
        beforeDestroy() {
            this.releasePdf();
        },
        methods: {
            // The report arrives as a Blob; the frame shows it from an object URL, released when
            // it is replaced or the page closes. A guest gets the viewer without its toolbar.
            showPdf(blob) {
                this.releasePdf();
                this.pdfsrc = URL.createObjectURL(blob) + (this.$store.state.memberId == 'TestMember' ? '#toolbar=0' : '');
            },
            releasePdf() {
                if (this.pdfsrc) {
                    URL.revokeObjectURL(this.pdfsrc.split('#')[0]);
                    this.pdfsrc = '';
                }
            },
            getFanPdf(proId) {
                this.isLoading = true;
                this.pdfFailed = false;
                api.panels.getFanPdf(this.$lang.Format.Lang, this.$store.state.memberId, proId).then((res) => {
                    this.isLoading = false;
                    if (res.isError) {
                        this.pdfFailed = true;
                        return;
                    }
                    this.showPdf(res.data);
                });
            },
            previous() {
                this.$store.isPageOpenedFromStepBar = false;
                router.push('/fan_Calc');
            }
        }
    };
</script>
